var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 61 61",
    fill: "#189AB4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10907_8141)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64632 46.6893L18.5831 32.7528L23.2249 37.3948L28.6384 31.9813L18.5831 21.926C12.8121 27.6971 7.04132 33.4678 1.27026 39.2389C2.06219 41.892 3.20554 44.3934 4.64632 46.6893Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4644 53.4971C12.4231 55.2051 14.6024 56.6669 16.9535 57.8347C26.0027 48.7855 35.0522 39.7363 44.1011 30.6871L57.7094 44.2954C58.9848 41.7848 59.9225 39.074 60.4637 36.223C55.0093 30.7689 49.5555 25.3142 44.1011 19.8604C32.8887 31.0727 21.6767 42.2847 10.4644 53.4971Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4958 43.1816L6.00354 48.6739C6.84336 49.8038 7.75914 50.8736 8.74386 51.8757L14.1574 46.4622C13.1733 45.4549 12.2813 44.3567 11.4958 43.1816Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.603097 36.5644L7.67766 29.4898C8.20632 17.3418 18.2219 7.65539 30.5002 7.65539C41.2659 7.65539 50.2919 15.1021 52.7089 25.1257L60.8743 33.2911C60.9576 32.372 61.0003 31.4409 61.0003 30.5002C61 13.6552 47.3448 0 30.5002 0C13.6555 0 0 13.6552 0 30.5002C0 32.5767 0.207743 34.6047 0.603097 36.5647"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8883 40.8157C47.1199 48.2496 39.405 53.3446 30.5001 53.3446C28.7345 53.3446 27.0155 53.1442 25.3648 52.765L19.2655 58.8643C22.7422 60.2426 26.5326 61 30.5001 61C41.5032 61 51.1457 55.1735 56.5101 46.4373L50.8883 40.8157Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.1f121d76e1c6d9bec6f4b85dbd420e17.svg";
export { ForwardRef as ReactComponent };